import React from 'react'

export const EventAttendanceIcon: React.FC = () => (
  <svg viewBox='0 0 33 33' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M10.2051 24.0134L16.8046 11.9312L23.6073 23.5058'
      stroke='currentColor'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M23.5056 9.69726L16.9061 21.7795L10.1034 10.2049'
      stroke='currentColor'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M31.4136 15.9135C31.5454 19.2639 30.5451 22.5611 28.5741 25.2736C26.603 27.986 23.7761 29.9558 20.5488 30.8654C17.3216 31.775 13.882 31.5714 10.7846 30.2874C7.68722 29.0034 5.11238 26.7139 3.47514 23.7878C1.83789 20.8617 1.23361 17.4696 1.7597 14.1581C2.28578 10.8467 3.91159 7.8088 6.37507 5.53421C8.83854 3.25961 11.9962 1.88077 15.339 1.61995C18.6818 1.35913 22.0151 2.23151 24.8016 4.09648'
      stroke='currentColor'
      strokeWidth='2'
      strokeLinecap='round'
    />
  </svg>
)
